<!-- 线性图表 -->
<template>
  <div class="echarts">
    <div :ref="echartName" :style="'height:'+height"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: 'LineChart',
  components: {},
  props: {
    echartData: {
      type: Object,
      default() {
        return null
      }
    },
    echartName: {
      type: String,
      default: "echarts"
    },
    height: {
      type: String,
      default: "200px"
    },
    isLine: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      chartOptions: {
        legend: {
          data: [],
          icon: "circle",
          right: 10,
          top: 10,
          textStyle: {
            color: '#9292C1'
          }
        },
        grid: {
          left: "3%",
          right: "3%",
          bottom: "3%",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis"
        },
        xAxis: {
          type: "category",
          data: [],
          axisTick: {
            show: false // 不显示刻度线
          },
          axisLine: {
            show: false  //不显示坐标轴线
          },
          axisLabel: { // 控制轴标签样式
            textStyle: {
              color: '#9292C1' // 设置横坐标轴标签文字颜色
            }
          }
        },
        yAxis: {
          type: "value",
          axisTick: {
            show: false // 不显示刻度线
          },
          splitLine: {  // 去掉网格线
            show: this.isLine,
            lineStyle: {
              type: 'dashed', // 设置虚线类型
              color: '#5A5A89'
            }
          },
          axisLine: { // 控制轴线样式
            show: false,  //不显示坐标轴线
            lineStyle: {
              color: '#9292C1' // 设置横坐标轴线的颜色
            }
          },
          axisLabel: { // 控制轴标签样式
            show: this.isLine,
            textStyle: {
              color: '#9292C1' // 设置横坐标轴标签文字颜色
            },
            formatter: '{value}'
          },
          axisPointer: {
            snap: true
          }
        },
        series: []
      },
      echarts: null,
      a: 'ge'
    }
  },
  created() {
  },
  mounted() {
    this.calcEcharts()
  },
  methods: {
    calcEcharts() {
      if (!this.echarts) {
        this.echarts = echarts.init(this.$refs[this.echartName]);
        // 添加窗口改变监听
        this.echarts._resize = () => {
          this.echarts.resize();
        };
        window.addEventListener("resize", this.echarts._resize);
      }
      this.chartOptions.legend.data = this.echartData.yAxisData.map(it => it.name);
      this.chartOptions.xAxis.data = this.echartData.xAxisData;
      this.chartOptions.series = this.echartData.yAxisData;
      this.refreshChart();
    },
    refreshChart() {
      let myChart = this.echarts;
      if (!this.echarts) {
        myChart = echarts.init(this.$refs.echarts);
      }
      myChart.clear();
      myChart.setOption(this.chartOptions);
    }
  },
  watch: {
    echartData(newVal) {
      this.calcEcharts()
    }
  }
}
</script>
<style lang='scss' scoped>
.echarts {
  width: 100%;
  height: 400px;
}
</style>
